import { combineLatest, map, Observable } from 'rxjs';
import { toRequestResult } from '../adapter/to-request-result';
import { RequestResult } from '../models/request-result';
import { getRequestState } from '../utils/request-status-tracker';

export const joinRequestResult =
  <T, E = unknown>(key: unknown[]) =>
  (o: Observable<T>): Observable<RequestResult<T, E>> =>
    combineLatest([o, getRequestState(key)]).pipe(map(([data, result]) => toRequestResult({ ...result, data })));
